export default __webpack_public_path__ + "static/media/330_dummy2016-heilpraxis01-mobile-de.53ff71f8.png";